export default function reduceOrders(orders, onlyAttest = false) {
  return orders.reduce((acc, order) => {
    acc[order.id] = {
      ...order
    }
    return acc
  }, {})
}



// WEBPACK FOOTER //
// ./src/modules/OrderHistory/helpers/reduceOrders.js